// extracted by mini-css-extract-plugin
export default {"root":"CEwry","mobile":"VEyz3","grid":"pkvxY","label":"CU4Rw","offer":"uR1br"};